"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = exports.Events = exports.Event = void 0;
const Event_1 = __importDefault(require("./Event"));
exports.Event = Event_1.default;
const VideoPresentationEvents = __importStar(require("./videopresentation/index"));
const FilePresentationEvents = __importStar(require("./filepresentation/index"));
const ConferenceEvents = __importStar(require("./conference/index"));
const RecordingEvents = __importStar(require("./recording/index"));
const CommandEvents = __importStar(require("./command/index"));
const NotificationEvents = __importStar(require("./notification/index"));
const SessionEvents = __importStar(require("./session/index"));
/**
 * @ignore
 */
const Events = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ConferenceEvents), FilePresentationEvents), VideoPresentationEvents), RecordingEvents), CommandEvents), NotificationEvents), SessionEvents);
exports.Events = Events;
/**
 * @ignore
 */
const EventType = {};
exports.EventType = EventType;
Object.keys(Events).forEach((k) => (EventType[k] = k));
